// src/lib/currency.ts
// Єдине джерело правди для валют відображення.
//   - Валюта = функція мови інтерфейсу (ru→RUB, uk→UAH, en→USD).
//   - Каталог/PDP/кошик/чекаут конвертують USD→валюту НАЖИВО за поточним курсом.
//   - Оформлене замовлення ЗАМОРОЖУЄ валюту+суму+курс (знімок) і більше не
//     переконвертовується — чек показує рівно те, що списали.

export const LANG_CURRENCY: Record<string, string> = { ru: 'RUB', uk: 'UAH', en: 'USD' };

export const CURRENCY_LOCALE: Record<string, string> = { USD: 'en-US', RUB: 'ru-RU', UAH: 'uk-UA' };

/** Валюта відображення за мовою інтерфейсу. */
export function currencyForLang(lang: string): string {
  return LANG_CURRENCY[lang] ?? 'USD';
}

/**
 * Конвертація базової ціни (USD) у валюту відображення з націнкою курсу.
 * USD лишається як є (rate=1). Для RUB/UAH округлюємо до цілого.
 */
export function convertFromUsd(usd: number, rate: number, markupPct: number, currency: string): number {
  if (currency === 'USD' || !rate) return usd;
  return Math.round(usd * rate * (1 + (markupPct ?? 0) / 100));
}

/** Форматування суми у валюті (для чека/історії — за збереженою валютою знімка). */
export function formatMoney(amount: number, currency: string): string {
  const locale = CURRENCY_LOCALE[currency] ?? 'en-US';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency', currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: currency === 'USD' ? 2 : 0,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}
